module.exports = __webpack_public_path__ + "img/newsCenterImg1.a36126dd.png";